<div @fade
    *ngIf="fadeInFadeOut && corelibService.getSecurityInformation().userProfile!=null || (isPublicRegistration && (publicRegistrationStatus == null || publicRegistrationStatus=='CONFIRMED'))">
    <form [formGroup]="signUpForm" class="ml-1 mr-1" *ngIf="signUpForm" id="signUpForm">
        <div class="mt-2 text-right" formArrayName="attendees">
            <p class="text-left font-bold signupTitle" *ngIf="this.getattendees().length > 0"
                i18n="@@event-registration.component.header.SignUpsTitle">Sign-Up</p>
            <div *ngFor="let item of this.signUpForm.get('attendees')['controls']; let i = index">
                <div *ngIf="i == 1" i18n="@@event-registration.component.additionalPerson"
                    class="text-left mt-4 font-bold additionalSignup">Additional attendees</div>
                <div [formGroupName]="i" class="flex mt-2">
                    <input type="hidden" formControlName="id">
                    <div class="flex flex-column flex-1 mt-2" *ngIf="item.get('id').value == null">
                        <div class="text-left mt-2 mb-4" [innerHTML]="event.registrationForm.header"
                            *ngIf="event.registrationForm?.header"></div>
                        <div class="flex">
                            <div class="flex-1 mb-2 pt-1 text-left attendeeFirstname">
                                <label class="pl-1" for="firstname">{{registrationPaceholders.firstname}}</label>
                                <input pInputText type="text" class="inputfield w-full" formControlName="firstname"
                                    autofocus id="firstname" aria-describedby="FirstNameError">
                                <div *ngIf="item.get('firstname').invalid && (item.get('firstname').dirty || item.get('firstname').touched)"
                                    i18n="@@appointment-management-list.error.firstNameRequired"
                                    class="form-text p-error text-left errorText" id="FirstNameError">
                                    A first name is required.
                                </div>
                            </div>
                            <div class="ml-1 flex-1 mb-2 pt-1 text-left attendeeName">
                                <label class="pl-1" for="name">{{registrationPaceholders.name}}</label>
                                <input pInputText type="text" class="inputfield w-full" formControlName="name" id="name"
                                    aria-describedby="LastNameError">
                                <div *ngIf="item.get('name').invalid && (item.get('name').dirty || item.get('name').touched)"
                                    i18n="@@appointment-management-list.error.lastNameRequired"
                                    class="form-text p-error text-left errorText" id="LastNameError">
                                    A last name is required.
                                </div>
                            </div>
                        </div>
                        <div class="mb-2 pt-1 text-left attendeeEmail">
                            <label class="pl-1" for="email">{{registrationPaceholders.email}}</label>
                            <input pInputText type="text" class="inputfield w-full" formControlName="email" id="email"
                                aria-describedby="EmailError">
                            <div *ngIf="item.get('email').invalid && (item.get('email').dirty || item.get('email').touched)"
                                i18n="@@appointment-management-list.error.email"
                                class="form-text p-error text-left errorText" id="EmailError">
                                Please enter a valid email address.
                            </div>
                        </div>
                        <div class="mb-2 pt-1 text-left attendeePhone">
                            <label class="pl-1" for="phoneNumber">{{registrationPaceholders.phoneNumber}}</label>
                            <input pInputText type="text" class="inputfield w-full" formControlName="phoneNumber"
                                id="phoneNumber" aria-describedby="PhoneNumberError">
                            <div *ngIf="item.get('phoneNumber').invalid && (item.get('phoneNumber').dirty || item.get('phoneNumber').touched)"
                                i18n="@@appointment-management-list.error.phoneNumber"
                                class="form-text p-error text-left errorText" id="PhoneNumberError">
                                A phone number is required.
                            </div>
                        </div>
                        <div class="mb-2 pt-1 text-left attendeeComment">
                            <label class="pl-1" for="comment">{{registrationPaceholders.comment}}</label>
                            <textarea pInputTextarea id="comment" class="block w-full" rows="3"
                                formControlName="comment" aria-describedby="CommentError"></textarea>
                            <div *ngIf="item.get('comment').invalid && (item.get('comment').dirty || item.get('comment').touched)"
                                i18n="@@appointment-management-list.error.commentRequired"
                                class="form-text p-error text-left errorText" id="CommentError">
                                A comment is required.
                            </div>
                        </div>
                        <div formGroupName="formData" *ngIf="event.registrationForm"
                            class="text-left dynamicRegistrationForm">

                            <div class="mb-2 pt-1 inputFieldContainer"
                                *ngFor="let field of event.registrationForm.fields"
                                [class.text-left]="field.datatype ==='BOOLEAN' || field.datatype ==='DATE'">

                                <ng-container *ngIf="field.datatype ==='STRING'">
                                    <label class="pl-1" [for]="field.propertyName">{{field.mandatory?field.columnName+'
                                        *':field.columnName}}</label>
                                    <input pInputText type="text" class="inputfield w-full"
                                        [formControlName]="field.propertyName" [id]="field.propertyName"
                                        aria-describedby="fieldRequiredError">
                                </ng-container>

                                <ng-container *ngIf="field.datatype ==='TEXT'">
                                    <label class="pl-1" [for]="field.propertyName">{{field.mandatory?field.columnName+'
                                        *':field.columnName}}</label>
                                    <textarea pInputTextarea class="block w-full" rows="3"
                                        [formControlName]="field.propertyName" [id]="field.propertyName"
                                        aria-describedby="fieldRequiredError"></textarea>
                                </ng-container>

                                <ng-container *ngIf="field.datatype ==='NUMBER'">
                                    <label class="pl-1" [for]="field.propertyName">{{field.mandatory?field.columnName+'
                                        *':field.columnName}}</label>
                                    <p-inputNumber [formControlName]="field.propertyName" [id]="field.propertyName"
                                        class="inputfield w-full" [style]="{'width':'100%'}"
                                        aria-describedby="fieldRequiredError"> </p-inputNumber>
                                </ng-container>

                                <ng-container *ngIf="field.datatype ==='DATE'">
                                    <label class="pl-1" [for]="field.propertyName">{{field.mandatory?field.columnName+'
                                        *':field.columnName}}</label>
                                    <input type="date" class="p-inputtext p-component w-full" [id]="field.propertyName"
                                        [formControlName]="field.propertyName" aria-describedby="fieldRequiredError"
                                        aria-haspopup="dialog"
                                        [attr.aria-label]="'Select a date for ' + field.columnName + ', opens calendar'"
                                        i18n-aria-label="@@appointment-management-list.datepicker.openCalendar">
                                </ng-container>

                                <ng-container *ngIf="field.datatype ==='FLOAT'">
                                    <label class="pl-1" [for]="field.propertyName">{{field.mandatory?field.columnName+'
                                        *':field.columnName}}</label>
                                    <p-inputNumber [formControlName]="field.propertyName" [minFractionDigits]="2"
                                        [id]="field.propertyName" class="inputfield w-full" [style]="{'width':'100%'}"
                                        [maxFractionDigits]="2" aria-describedby="fieldRequiredError">
                                    </p-inputNumber>
                                </ng-container>

                                <ng-container *ngIf="field.datatype ==='BOOLEAN'">
                                    <p-checkbox [binary]="true" [formControlName]="field.propertyName"
                                        [id]="field.propertyName" [inputId]="field.propertyName"
                                        aria-describedby="fieldRequiredError">
                                    </p-checkbox>
                                    <label
                                        [for]="field.propertyName">{{field.mandatory?field.columnName+'*':field.columnName}}</label>
                                </ng-container>

                                <ng-container *ngIf="field.datatype ==='ENUM' && extendedFieldEnumValues">
                                    <label class="pl-1" [for]="field.propertyName">{{field.mandatory?field.columnName+'
                                        *':field.columnName}}</label>
                                    <p-select [options]="extendedFieldEnumValues[field.columnName]"
                                        [id]="field.propertyName" [formControlName]="field.propertyName" appendTo="body"
                                        [style]="{'width':'100%'}" class="text-left"
                                        aria-describedby="fieldRequiredError">
                                    </p-select>
                                </ng-container>


                                <div *ngIf="item.get('formData').get(field.propertyName).invalid && (item.get('formData').get(field.propertyName).dirty || item.get('formData').get(field.propertyName).touched)"
                                    i18n="@@appointment-management-list.error.genericRequired"
                                    class="form-text p-error text-left errorText" id="fieldRequiredError">
                                    This field is required
                                </div>

                            </div>
                        </div>
                        <div class="text-left mt-2 mb-4 registrationFooter" [innerHTML]="event.registrationForm.footer"
                            *ngIf="event.registrationForm?.footer"></div>
                        <div class="flex flex-row justify-content-between">
                            <div>
                                <p-inputgroup *ngIf="familyProfiles.length > 0">
                                    <p-select [options]="familyProfiles" optionLabel="name"
                                        [(ngModel)]="selectedFamilyProfile" class="w-12rem" appendTo="body"
                                        [ngModelOptions]="{standalone: true}" placeholder="Family member"
                                        i18n-placeholder="@@appointment-management-list.familyMember.select.placeholder">
                                        <ng-template #selectedItem let-member>
                                             <span *ngIf="member" class="flex align-items-center">
                                                <div class="ml-1">
                                                    {{ member.firstname }}
                                                </div>
                                                <div class="ml-1">
                                                    {{ member.name }}
                                                </div>
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="item" let-member>
                                            <span *ngIf="member" class="flex align-items-center">
                                                <p-avatar 
                                                    [image]="'/file-api/userprofile/image/' + member.id + '?thumbnail=true&imageId=' + member.imageId + '&access_token=' + corelibService.getJWTToken()"
                                                    shape="circle" />
                                                <div class="ml-1 text-sm">
                                                    {{ member.firstname }}
                                                </div>
                                                <div class="ml-1 text-sm">
                                                    {{ member.name }}
                                                </div>
                                            </span>
                                        </ng-template>
                                    </p-select>
                                    <p-inputgroup-addon>
                                        <p-button icon="pi pi-check" severity="secondary"
                                            [disabled]="selectedFamilyProfile == null"
                                            (onClick)="adaptFamilyProfileToForm(i)" />
                                    </p-inputgroup-addon>

                                </p-inputgroup>
                            </div>
                            <p-button icon="far fa-trash" class="align-self-start" severity="danger" [text]="true"
                                type="button" (click)="onDeleteAttendee(i)" ariaLabel="Delete registration"
                                i18n-ariaLabel="@@appointment-management-list.buttons.deleteRegistration"></p-button>
                        </div>
                    </div>
                    <div class="flex flex-row align-items-center flex-1 text-left existing-registration shadow-1 p-2"
                        *ngIf="item.get('id').value != null">
                        <div class="flex-1">
                            <div style="word-break: break-all;" class="font-bold registrationName">
                                {{item.get('firstname').value}}
                                {{item.get('name').value}}</div>
                            <div style="word-break: break-all;" class="registrationEmail">{{item.get('email').value}}
                            </div>
                            <div class="registrationPhone">{{item.get('phoneNumber').value}}</div>
                            <div class="text-sm registrationComment">{{item.get('comment').value}}</div>
                            <div class="mt-2 text-green-600 flex text-center registrationStatus"
                                *ngIf="event.ownRegistrations[i].status ==='ATTENDED'">
                                <div><i class="fal fa-handshake" aria-hidden="true"></i></div>
                                <div i18n="@@event-registration.participation-confimed" class="ml-1">Participation
                                    confirmed</div>
                            </div>
                            <div class="mt-2 text-green-600 flex text-center registrationPayment"
                                *ngIf="event.ownRegistrations[i].payed == true">
                                <div><i class="fal fa-euro-sign" aria-hidden="true"></i></div>
                                <div i18n="@@event-registration.payment-confimed" class="ml-1">Payment confirmed</div>
                            </div>
                            <div class="mt-2 text-orange-600 flex  flex-column registrationPaymentPending"
                                *ngIf="event.ownRegistrations[i].status == 'RESERVED' ">
                                <div class="flex"
                                    *ngIf="event.ownRegistrations[i].payed == false && paymentEnabled==true">
                                    <div><i class="fal fa-euro-sign" aria-hidden="true"></i></div>
                                    <div i18n="@@event-registration.outstanding-payment" class="ml-1">Pending
                                        payment </div>

                                </div>
                                <div>
                                    <p-tag severity="info" class="mt-2">
                                        <span i18n="@@event-registration.reserved-until" class="mr-1">Reserved
                                            until:</span>{{reservedUntil(event.ownRegistrations[i]) | date:'short'}}
                                    </p-tag>
                                </div>


                            </div>

                            <div class="flex flex-row justify-content-end mt-2 registrationTicket"
                                *ngIf="event.ownRegistrations[i].status ==='CONFIRMED' && event.issueTicketsUponRegistration">
                                <p-button label="Show ticket" i18n-label="@@event-registration.showTicket" [text]="true"
                                    class="align-self-start ticketButton" type="button" severity="secondary"
                                    (click)="onShowTicket(i)"></p-button>
                                <p-dialog [focusOnShow]="false" i18n-header="@@event-registration.showTicket.header"
                                    header="Ticket" [(visible)]="showTicket[i]" [modal]="true" [draggable]="false"
                                    [dismissableMask]="true" [focusTrap]="true" closeAriaLabel="Close"
                                    i18n-closeAriaLabel="@@event-registration.showTicket.Close" id="ticketQRCode"
                                    (onShow)="onModalShow('ticketQRCode')" *ngIf="showTicket">
                                    <img [src]="apiURL + '/file-api/qrcode?code=' + event.ownRegistrations[i].id + '&thumbnail=false&access_token=' + corelibService.getJWTToken() + '&size=300'"
                                        style="width:300px;height: 300px;" alt="QR-Code"
                                        i18n-alt="@@appointment-management-list.buttons.qrCode" />

                                    <div style="word-break: break-all;" class="font-bold ticketDetails">
                                        {{item.get('firstname').value}}
                                        {{item.get('name').value}}</div>
                                    <div style="word-break: break-all;">{{item.get('email').value}}</div>
                                </p-dialog>

                                <p-button icon="far fa-trash" class="align-self-start ml-1 deleteButton"
                                    severity="danger" [text]="true" type="button" (click)="onDeleteAttendee(i)"
                                    ariaLabel="Delete attendee"
                                    i18n-ariaLabel="@@appointment-management-list.buttons.deleteAttendee"></p-button>
                            </div>
                        </div>
                        <div class="text-right ml-1"
                            *ngIf="!(event.ownRegistrations[i].status ==='CONFIRMED' && event.issueTicketsUponRegistration) && event.ownRegistrations[i].payed == false">
                            <p-button icon="far fa-trash" class="align-self-start deleteButton" type="button"
                                severity="danger" [text]="true" (click)="onDeleteAttendee(i)"
                                ariaLabel="Delete attendee"
                                i18n-ariaLabel="@@appointment-management-list.buttons.deleteAttendee"></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-2 flex flex-column captcha"
            *ngIf="isPublicRegistration && (canSubmit || canSubmitTowaitingList)">
            <div class="flex align-items-center">
                <div class="flex-1 bg-contain bg-no-repeat captchaImage" style="height:200px"
                    [style.background-image]="captchaControl.captcha.image"></div>
                <div class="ml-2">
                    <p-button icon="far fa-refresh" class="refreshButton" (onClick)="requestNewCaptcha()"
                        ariaLabel="Request new captcha"
                        i18n-ariaLabel="@@appointment-management-list.buttons.requestNewCaptcha"></p-button>
                </div>
            </div>

            <div class="flex-1 field mt-2 captchaInput">
                <label class="pl-1" for="captcha" i18n="@@appointment-management-edit.label.enterCaptcha">Enter
                    captcha</label>
                <input pInputText type="text" class="inputfield w-full" [(ngModel)]="captchaControl.code"
                    [ngModelOptions]="{standalone: true}" autofocus id="captcha">
            </div>
        </div>

        <div class="text-right mt-4">
            <p-button *ngIf="paymentEnabled && !allPayed" label="Pay now" i18n-label="@@event-registration.pay-now"
                styleClass="mb-2 mr-2" class="payButton" (onClick)="pay.emit(this.event)"
                severity="secondary"></p-button>
            <button *ngIf="canAddAttendee" [outlined]="paymentEnabled && !allPayed" pButton
                class="mb-2 p-button-secondary addButton" i18n-label="@@event-registration.component.button.addUser"
                icon="far fa-plus" label="Add registration" type="button" (click)="addAttendee()"></button>

            <button *ngIf="canSubmitTowaitingList" pButton class="mb-2 ml-2 p-button-secondary waitinglistButton"
                iconPos="left" [disabled]='!signUpForm.valid' (click)="onSubmitConfirmSignUp()"
                i18n-label="@@event-registration.component.button.put-on-waiting-list"
                label="Put on waiting list"></button>

            <button *ngIf="canSubmit" pButton class="mb-2 ml-2 p-button-secondary submitButton" iconPos="left"
                (click)="onSubmitConfirmSignUp()" i18n-label="@@event-registration.component.button.register"
                label="Sign up"></button>

            <div *ngIf="event.multiSignUpAllowed==true && this.getattendees().length > event.maxAdditionalSignUps && newAttendees().length == 0"
                class="font-bold maxSignupsHintText" i18n="@@appointment-management-list.error.maxSignUpsReached">
                <span>Maximum amount of additional registrations reached.</span>
            </div>
        </div>
    </form>

</div>
<div *ngIf="(isPublicRegistration && publicRegistrationStatus=='RESERVED')" class="reservedHintText">
    <p-message severity="info">
        <span i18n="@@event-registration.publ-registration-reserved-text">Thank you for your registration. To finalise
            your registration, please click on the confirmation link in the email we have just sent you.</span>
    </p-message>
</div>

<div *ngIf="(isPublicRegistration && publicRegistrationStatus=='QUEUED')" class="queuedHintText">
    <p-message severity="info">
        <span i18n="@@event-registration.publ-registration-queued-text">You have been added to the waiting list. You
            will be informed as soon as a place becomes available.</span>
    </p-message>
</div>

<div *ngIf="(isPublicRegistration && publicRegistrationStatus=='CONFIRMED')" class="confirmedHintText">
    <p-message severity="success">
        <span i18n="@@event-registration.publ-registration-confirmed-text">You are registered.</span>
    </p-message>
</div>
<div *ngIf="corelibService.getSecurityInformation().userProfile === null && !event.publicRegistrationAllowed"
    class="noProfileHintText">
    <p-message severity="info">
        <span i18n="@@event-registration.component.noProfile.infoText">Profile needed for registrations.</span>
    </p-message>
</div>

<p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" key="cancelSignUp"
    position="top-center"></p-toast>
<p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" key="submitSignUp"
    position="top-center"></p-toast>

<p-confirmDialog key="cancelSubscriptionDialog" id="cancelSubscriptionDialog">

    <ng-template pTemplate="message" let-message>
        <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
            <p>{{ message.message }}</p>

            <div class="w-full">
                <textarea pInputTextarea class="block w-full" rows="6" [(ngModel)]="cancelSubscriptionReason"
                    placeholder="Please state the reason for the cancellation"
                    i18n-placeholder="@@event-registration.unregistration-reason.placeholder"></textarea>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>